import * as React from "react";
import Page, { PageProps } from "../Page";
import { IDynamicQueriesPresenter } from "../../../presenter/dynamicQuery/DynamicQueriesPresenter";
import Loader from "../../components/Loader";
import DataGrid from "../../components/app/grid/DataGrid";
import { IDisplayConfiguration } from "../../../model/editform/DisplayConfiguration";
import { IFormItem } from "../../../model/editform/FormItem";
import { Form } from "antd";
import EditForm, {
  CreateUpdateEditFormProps
} from "../../components/app/editor/form/EditForm";

export interface Props extends PageProps {}
export interface State extends IDynamicQueriesPresenter {}

export default class DynamicQueriesPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      dynamicQueries,
      createDynamicQuery,
      updateDynamicQuery,
      deleteDynamicQuery
    } = this.state;

    let { dynamicQueriesLoader } = this.state.loaders;

    const columns = [
      {
        title: translate("dynamic_queries.code"),
        dataIndex: "code",
        key: "code"
      },
      {
        title: translate("dynamic_queries.description"),
        dataIndex: "description",
        key: "description"
      }
    ];

    const formItems = [
      {
        type: "input",
        name: "code",
        displayConfiguration: {
          required: true
        } as IDisplayConfiguration
      },
      {
        type: "input",
        name: "description",
        displayConfiguration: {
          required: true
        } as IDisplayConfiguration
      },
      {
        type: "textarea",
        name: "sqlQuery",
        displayConfiguration: {
          minRows: 3,
          required: true
        } as IDisplayConfiguration
      }
    ] as IFormItem[];

    const CreateForm = Form.create<CreateUpdateEditFormProps>({})(EditForm);

    CreateForm.defaultProps = {
      formItems: formItems,
      onSubmit: createDynamicQuery
    };

    const UpdateForm = Form.create<CreateUpdateEditFormProps>({})(EditForm);

    UpdateForm.defaultProps = {
      formItems: formItems,
      onSubmit: updateDynamicQuery
    };

    return (
      <Page {...this.props}>
        <Loader translate={translate} loading={dynamicQueriesLoader || false}>
          <DataGrid
            title={translate("grids.dynamic-queries")}
            translate={translate}
            columns={columns}
            dataSource={dynamicQueries}
            allowCreate={true}
            allowDelete={true}
            allowUpdate={true}
            createForm={CreateForm}
            onCreate={createDynamicQuery}
            createModalTitle={translate("dynamic_queries.create_modal_title")}
            updateForm={UpdateForm}
            onUpdate={updateDynamicQuery}
            updateModalTitle={translate("dynamic_queries.update_modal_title")}
            addButtonText={translate("dynamic_queries.add_button_text")}
            onDelete={deleteDynamicQuery}
            deleteModalTitle={translate("dynamic_queries.delete_modal_title")}
            deleteModalMessage={translate(
              "dynamic_queries.delete_modal_message"
            )}
            expandedRowRender={(record) => (
              <p
                style={{
                  margin: 0,
                  fontFamily: "Courier New",
                  whiteSpace: "pre-wrap"
                }}
              >
                {record.sqlQuery}
              </p>
            )}
          />
        </Loader>
      </Page>
    );
  }
}
